import React from 'react';
import { Badge, IconButton } from '@mui/material';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { useNavigate } from 'react-router-dom';

import { getCartCount } from '../../services/cartService';
import { useAppSelector } from '../../store/hooks';

interface CartIconButtonProps {
  color?: 'default' | 'inherit' | 'primary' | 'secondary';
}

const CartIconButton: React.FC<CartIconButtonProps> = ({ color = 'inherit' }) => {
  const navigate = useNavigate();
  const cartItems = useAppSelector((state) => state.cart.items);
  const cartCount = getCartCount(cartItems);

  return (
    <IconButton color={color} aria-label="cart" onClick={() => navigate('/cart')}>
      <Badge badgeContent={cartCount} color="error">
        <ShoppingCartOutlinedIcon />
      </Badge>
    </IconButton>
  );
};

export default CartIconButton;
